<ngu-carousel #myCarousel [inputs]="carouselConfig" [dataSource]="carouselItems" *ngIf="carouselItems.length">
	<div *nguCarouselDef="let item;" class="item">
		<img [src]="item.data" class="preview" (click)="redirectTo(item.link)">
	</div>
	<button NguCarouselNext class="rightRs"></button>
	<button NguCarouselPrev class="leftRs"></button>
	<ul class="myPoint" NguCarouselPoint>
		<li *ngFor="let i of carouselItems; let j = index" [class.active]="j==myCarousel.activePoint" (click)="myCarousel.moveTo(j)"></li>
	</ul>
</ngu-carousel>